const topK = process.env.REACT_APP_TOP_K || '16';

export const similaritySettings = {
  topK: topK,
};
